export { BeveragesGallery } from "./BeveragesGallery";
